import { memo } from 'react';
import { Modal } from '@maxtropy/components';
import HighEnergy from '../HighEnergy';
import styles from './index.module.scss';

interface HighEnergyModalProps {
  open: boolean;
  onClose: () => void;
  activeId?: number;
}

const HighEnergyModal: React.FC<HighEnergyModalProps> = ({ open, onClose, activeId }) => {
  return (
    <Modal
      open={open}
      className={styles.customModal}
      onCancel={onClose}
      footer={null}
      title="10kV变压器负载率排名"
      size="big"
      destroyOnClose
      getContainer={() => document.getElementById('full_screen_box') ?? document.body}
    >
      <HighEnergy activeId={activeId} />
    </Modal>
  );
};

export default memo(HighEnergyModal);
